module.exports = "/images/logo.jpg?23dff7de2bdb76a4d812c11c141b0601";